import React, { useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthService from "../services/auth-service";
import MuiAlert from "@mui/material/Alert";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import Select from "@mui/material/Select";
import { MenuItem, FormControl, InputLabel, ListItemText } from "@mui/material";




const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const isValidEmail = (email) =>
  /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/.test(email);
const isValidPassword = (password) =>
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{6,12})/.test(
    password
  );

// Reusable input field with improved styling
const InputField = React.memo(
  ({ label, type = "text", value, onChange, error, placeholder }) => (
    <div style={{ marginBottom: 22 }}>
      <label
        style={{
          display: "block",
          marginBottom: 7,
          fontWeight: 600,
          color: "#222",
          letterSpacing: 0.2,
        }}
      >
        {label}
      </label>
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        style={{
          borderColor: error ? "#e57373" : "#e0e6ed",
          borderWidth: 1.5,
          borderRadius: 8,
          padding: "13px 16px",
          width: "100%",
          fontSize: 16,
          outline: "none",
          background: "#f9fbfd",
          transition: "border-color 0.2s, box-shadow 0.2s",
          boxShadow: error
            ? "0 0 0 2px #ffeaea"
            : "0 1px 2px rgba(60,60,60,0.03)",
        }}
        onFocus={(e) => (e.target.style.borderColor = "#1976d2")}
        onBlur={(e) =>
          (e.target.style.borderColor = error ? "#e57373" : "#e0e6ed")
        }
      />
      {error && (
        <span
          style={{
            color: "#e57373",
            fontSize: 13,
            marginTop: 4,
            display: "block",
          }}
        >
          {typeof error === "string" ? error : "This field is required"}
        </span>
      )}
    </div>
  )
);

// Select field with improved spacing
const SelectField = React.memo(({ value, onChange, error }) => (
  <FormControl
    style={{ width: "100%", marginBottom: 25 }}
    error={error}
    variant="outlined"
    size="small"
  >
    <InputLabel>Expert Type</InputLabel>
    <Select
      value={value}
      onChange={onChange}
      label="Expert Type"
      style={{
        width: "100%",
        background: "#f9fbfd",
        borderRadius: 8,
        fontSize: 16,
      }}
      renderValue={(val) =>
        val === 20 ? "Academic Expert" : val === 30 ? "Music Expert" : ""
      }
    >
      <MenuItem value={20}>
        <ListItemText primary="Academic Expert" />
      </MenuItem>
      <MenuItem value={30}>
        <ListItemText primary="Music Expert" />
      </MenuItem>
    </Select>
    {error && (
      <span style={{ color: "#e57373", fontSize: 13, marginTop: 4 }}>
        Please select an expert type
      </span>
    )}
  </FormControl>
));

// Loading button with better alignment and hover effect
const LoadingButton = ({ isLoading, children, onClick, type = "button" }) => (
  <button
    type={type}
    onClick={onClick}
    className="btn_three"
    disabled={isLoading}
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: 120,
      minHeight: 44,
      fontSize: 16,
      fontWeight: 600,
      borderRadius: 8,
      background: isLoading ? "#90caf9" : "#1976d2",
      color: "#fff",
      border: "none",
      marginTop: 10,
      boxShadow: "0 2px 8px rgba(25, 118, 210, 0.08)",
      cursor: isLoading ? "not-allowed" : "pointer",
      transition: "background 0.2s, box-shadow 0.2s",
    }}
    onMouseOver={(e) => !isLoading && (e.target.style.background = "#1565c0")}
    onMouseOut={(e) => !isLoading && (e.target.style.background = "#1976d2")}
  >
    {isLoading && (
      <CircularProgress
        style={{ width: 22, height: 22, marginRight: 10 }}
        color="inherit"
      />
    )}
    {children}
  </button>
);

const SignUpForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    cpassword: "",
  });
  const [selectVal, setSelectVal] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [errors, setErrors] = useState({
    name: false,
    email: false,
    select: false,
  });
  const [emailErr, setEmailErr] = useState(false);
  const [passErr, setPassErr] = useState(false);
  const [cpassErr, setCpassErr] = useState(false);
  const [successSendingLink, setSuccessSendingLink] = useState(false);
  const [showPasswordTab, setShowPasswordTab] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [tutorExistence, setTutorExistence] = useState("");

  const history = useNavigate();

  const tutorType = useMemo(() => {
    return selectVal === 20 ? "Academic" : selectVal === 30 ? "Music" : "NA";
  }, [selectVal]);

  const handleInput = (field) => (e) => {
    setForm({ ...form, [field]: e.target.value });
    if (field === "email") setEmailErr(!isValidEmail(e.target.value));
    if (field === "password") setPassErr(!isValidPassword(e.target.value));
    if (field === "cpassword") setCpassErr(form.password !== e.target.value);
    if (errors[field]) setErrors({ ...errors, [field]: false });
  };

  const handleSelect = (e) => {
    setSelectVal(e.target.value);
    if (errors.select) setErrors({ ...errors, select: false });
  };

  const handleCheckbox = () => setIsChecked(!isChecked);

  const handleNext = async (e) => {
    e.preventDefault();
    const newErrors = {
      name: !form.name,
      email: !form.email,
      select: !selectVal,
    };
    setErrors(newErrors);
    if (Object.values(newErrors).some(Boolean) || !isChecked) return;

    try {
      setIsLoading(true);
      const checkEmail = await axios.post(
        "https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/tutorweb/checkEmail",
        { email: form.email.toLowerCase() }
      );

      if (!checkEmail.data.success) {
        const findTutor = await axios.post(
          "https://central-device-apis.el.r.appspot.com/d6/api/tutor/findTutorByEmail",
          { email: form.email.toLowerCase() }
        );

        if (findTutor.data.success) {
          setTutorExistence("new_but_exist");
          alert("Email already exists!");
          if (selectVal === 10) {
            const payload = {
              email: form.email.toLowerCase(),
              name: form.name,
              secret_id: findTutor?.data?.result?._id,
            };
            await axios.post(
              "https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/auth/oldTutorExist_mail",
              payload
            );
            setSuccessSendingLink(true);
          }
        } else {
          setShowPasswordTab(true);
        }
      } else {
        alert("Email already exists!");
      }
    } catch (err) {
      alert("An error occurred, please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    if (form.password !== form.cpassword)
      return alert("Passwords do not match!");

    setIsLoading(true);
    try {
      await AuthService.tutorSignup(
        form.email.toLowerCase(),
        form.password,
        form.name,
        tutorType
      );
      alert("Registered Successfully! Please Log In.");
      history("/tutorSignin");
    } catch (err) {
      alert(err.response?.data?.msg || "Signup failed");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section
      className="sign_in_area bg_color sec_pad"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(120deg, #e0e7ff 0%, #f7e6ff 100%)", // blue to purple bg
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <div className="container" style={{ maxWidth: 980 }}>
        <div
          className="sign_info"
          style={{
            boxShadow: "0 8px 32px rgba(60,60,60,0.10)",
            borderRadius: 18,
            background: "#fff",
            padding: 0,
            overflow: "hidden",
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          <div
            className="col-lg-6 d-none d-lg-flex"
            style={{
              background: "linear-gradient(120deg, #8e24aa 0%, #ce93d8 100%)", // purple gradient
              alignItems: "center",
              justifyContent: "center",
              flex: 1,
              minHeight: 520,
              padding: 0,
            }}
          >
            <img
              className="login-img"
              src={require("../img/home-chat/login.png")}
              alt=""
              style={{
                width: "80%",
                maxWidth: 340,
                borderRadius: 16,
                margin: "auto",
                boxShadow: "0 4px 24px rgba(142, 36, 170, 0.10)", // purple shadow
                background: "#fff",
                padding: 12,
              }}
            />
          </div>
          <div
            className="col-lg-6 col-12"
            style={{
              flex: 1,
              minWidth: 320,
              padding: "48px 32px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div
              className="login_info"
              style={{ width: "100%", maxWidth: 400, margin: "0 auto" }}
            >
              <h2
                className="f_p f_600 f_size_24 t_color3 mb_40"
                style={{
                  marginBottom: 32,
                  textAlign: "center",
                  fontWeight: 700,
                  color: "#8e24aa", // purple heading
                  letterSpacing: 0.5,
                }}
              >
                Tutor Sign Up
              </h2>
              <form
                className="login-form sign-in-form"
                onSubmit={showPasswordTab ? handleSignup : handleNext}
                style={{ width: "100%" }}
                autoComplete="off"
              >
                {!showPasswordTab ? (
                  successSendingLink ? (
                    <p
                      style={{
                        color: "#388e3c",
                        fontWeight: 500,
                        textAlign: "center",
                        fontSize: 16,
                        marginBottom: 24,
                      }}
                    >
                      We have sent a password link to your email.
                    </p>
                  ) : (
                    <>
                      <SelectField
                        value={selectVal}
                        onChange={handleSelect}
                        error={errors.select}
                      />
                      <InputField
                        label="Full Name"
                        value={form.name}
                        onChange={handleInput("name")}
                        error={errors.name}
                        placeholder="Full Name"
                      />
                      <InputField
                        label="Email Address"
                        value={form.email}
                        onChange={handleInput("email")}
                        error={errors.email}
                        placeholder="example@gmail.com"
                      />
                      {emailErr && (
                        <span style={{ color: "#e57373", fontSize: 13 }}>
                          Please enter a valid email!
                        </span>
                      )}
                      <div style={{ margin: "18px 0 10px 0" }}>
                        <input
                          type="checkbox"
                          checked={isChecked}
                          onChange={handleCheckbox}
                          id="terms"
                          style={{
                            marginRight: 8,
                            accentColor: "#1976d2",
                            width: 16,
                            height: 16,
                          }}
                        />
                        <label htmlFor="terms" style={{ fontSize: 14 }}>
                          I accept the{" "}
                          <a
                            href="/termsConditions"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#1976d2",
                              textDecoration: "underline",
                            }}
                          >
                            terms and conditions
                          </a>
                        </label>
                      </div>
                      <LoadingButton
                        onClick={handleNext}
                        isLoading={isLoading}
                        type="button"
                      >
                        Next
                      </LoadingButton>
                    </>
                  )
                ) : (
                  <>
                    <InputField
                      label="Password"
                      type="password"
                      value={form.password}
                      onChange={handleInput("password")}
                      error={
                        passErr &&
                        "Password must be 6-12 chars, include upper, lower, number, special char."
                      }
                      placeholder="******"
                    />
                    <InputField
                      label="Confirm Password"
                      type="password"
                      value={form.cpassword}
                      onChange={handleInput("cpassword")}
                      error={cpassErr && "Passwords do not match!"}
                      placeholder="******"
                    />
                    <LoadingButton isLoading={isLoading} type="submit">
                      Sign Up
                    </LoadingButton>
                  </>
                )}
              </form>
              <p style={{ marginTop: 28, textAlign: "center", fontSize: 15 }}>
                Already have an account?{" "}
                <Link
                  to="/TutorSignin"
                  style={{
                    color: "#8e24aa", // purple link
                    fontWeight: 600,
                    textDecoration: "underline",
                  }}
                >
                  Sign In
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SignUpForm;
